import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import moment from 'moment'
import { Journey } from 'components/forms'
import { MaterialModal } from 'components/layout'
import { apiConfiguration, apiAssessors, apiDashboard, apiCodeLists, apiCommon, apiLists } from 'helpers/decorators/api'
import { CONFIGURATION_KEYS } from 'constants/enums'
import { connect } from 'react-redux'
import { getAJDaysDiff } from 'helpers/dashboard'
import { form } from 'helpers/decorators'
import validate from './setup-pe.validation'
import { fetchSchemaAJParticipantEvent } from 'models/adventurousJourney'
import { asyncValidate } from '../../../../models/adventurousJourney/validateAssessor'



@apiDashboard.apiAdventurousJourney({
  refreshKey: 'awardId',
  loaders: ['setup']
})
@apiLists({ transportationMode: true })
@apiCodeLists(['titles', 'modeOfTransportTypeList'], {
  public: true
})
@apiCommon({
  publicCountries: true
})
@apiConfiguration()
@apiAssessors()
@connect(({ api }) => ({
  dashboard: api.dashboard,
}))
@form({
  form: 'setupParticipantEventJourney',
  dataKey: 'journey.ajEvent',
  initialPropsMapper: fetchSchemaAJParticipantEvent,
  disableHook: true,
  validate,
  asyncValidate
})
class SetupParticipantEventJourney extends Component {
  static propTypes = {
    pEId: PropTypes.any,
    onSetupParticipantEventJourney: PropTypes.func,
    onGetAJCategories: PropTypes.func,
    handleSubmit: PropTypes.func,
    reset: PropTypes.func,
    setupStatus: PropTypes.object,
    awardLevel: PropTypes.object,
    codeLists: PropTypes.object,
    aJValues: PropTypes.object,
    values: PropTypes.object,
    common: PropTypes.object,
    eventCategory: PropTypes.string,
    colorClass: PropTypes.string,
    change: PropTypes.func.isRequired,
    // eslint-disable-next-line
    onGetConfigurationValue: PropTypes.func.isRequired,
    // eslint-disable-next-line
    onGetAvailableAssessorsForActivityCategory: PropTypes.func.isRequired,
    lists: PropTypes.object.isRequired
  }


  async componentDidMount() {
    const { aJValues, onGetAJCategories } = this.props

    get(aJValues, 'data.awardLevel.value') &&
      onGetAJCategories(get(aJValues, 'data.awardLevel.value'))
    setTimeout(() => this.handleUpdate({}, this.props), 100)
  }
  async componentWillUpdate(newProps) {
    if (
      get(this.props, 'aJValues.data.awardLevel.value') !==
        get(newProps, 'aJValues.data.awardLevel.value') &&
      get(newProps, 'aJValues.data.awardLevel.value')
    ) {
      this.props.onGetAJCategories(
        get(this.props.aJValues, 'data.awardLevel.value')
      )
    }
    await this.handleUpdate(this.props, newProps)
  }
  getOrgId(props) {
    return get(props, 'dashboard.awards.awards.data.organization.id')
  }
  getSubCategory(props) {
    return get(props, 'values.activityCategory.id')
  }
  getIsAssessorManagementEnabled(props) {
    return get(props, `configuration.values.${CONFIGURATION_KEYS.isAssessorManagementEnabled.id}.booleanValue`)
  }
  async handleUpdate(props, newProps){
    const newOrgId = this.getOrgId(newProps)

    const newSubCategory = this.getSubCategory(newProps)

    const isAssessorManagementEnabled = this.getIsAssessorManagementEnabled(newProps)

    const orgIdChanged = (newOrgId !== this.getOrgId(props))

    const subCategoryChanged = (newSubCategory !== this.getSubCategory(props))

    const isAssessorManagementEnabledChanged = (isAssessorManagementEnabled !== this.getIsAssessorManagementEnabled(props))

    if (orgIdChanged) {
      await newProps.onGetConfigurationValue(
        CONFIGURATION_KEYS.isAssessorManagementEnabled.id,
        newOrgId,
        true)
    }
    if ((orgIdChanged || subCategoryChanged || isAssessorManagementEnabledChanged)
      && isAssessorManagementEnabled && newSubCategory && newSubCategory !== 'others' && newOrgId
    ) {
      newProps.onGetAvailableAssessorsForActivityCategory(newOrgId, newSubCategory)
    }
  }

  handleSubmit = fields => {
    const { pEId, aJValues, eventCategory } = this.props

    return this.props.onSetupParticipantEventJourney(
      get(aJValues, 'data'),
      fields,
      {
        resetForm: this.props.reset,
        eventCategory,
        pEId
      }
    )
  }

  render() {
    const {
      handleSubmit,
      setupStatus,
      colorClass,
      awardLevel,
      codeLists,
      aJValues,
      values,
      common,
      change,
      lists
    } = this.props

    const aJCategories = aJValues.categories
    const categoryValue = get(values, 'helpers.category')
    const subcategoryValue = get(values, 'activityCategory.id')
    const setupAssessorId = get(values, 'setupAssessorId')
    const startDate =
      moment.isMoment(get(values, 'startDate')) &&
      get(values, 'startDate').clone()
    const minEndDate =
      startDate &&
      startDate.add(getAJDaysDiff(get(awardLevel, 'value')), 'days')
    const isAssessorManagementEnabled = this.getIsAssessorManagementEnabled(this.props)
    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <Journey
          categoryValue={categoryValue}
          subcategoryValue={subcategoryValue}
          setupAssessorId={setupAssessorId}
          aJCategories={aJCategories}
          colorClass={colorClass}
          minEndDate={minEndDate}
          codeLists={codeLists}
          transportationModeList={lists.transportationMode.list}
          common={common}
          change={change}
          isAssessorManagementEnabled={isAssessorManagementEnabled}
        />
        <MaterialModal.Footer
          action="Setup"
          actionKey="button.setup"
          colorClass={colorClass}
          insideContent
          isLoading={get(setupStatus, 'loading')}
        />
      </form>
    )
  }
}

export default SetupParticipantEventJourney
